<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="errorMessage" class="info-alert row-space clickabe" @click="errorMessage=null">{{ errorMessage }}</div>

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">OS</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdos) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Inclusão</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtinclusao) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <div class="field-label">{{ objView.nmpessoa }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Localidade</label>
                <div class="field-label">{{ objView.nmlocalidade }}</div>
            </div>

            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Grupo</label>
                <div class="field-label">{{ objView.nmgrupo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Equipamento</label>
                <div class="field-label">{{ objView.nmequipamento }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Implemento</label>
                <div class="field-label">{{ objView.nmimplemento }}</div>
            </div>
        </div>
        

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Serviço</label>
                <div class="field-label">{{ objView.nmservico }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Contratado</label>
                <div class="field-label field-label-center">{{ objView.hrcontratadas }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Executado</label>
                <div class="field-label field-label-center">{{ objView.hrtrabalhadas }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Data/Hora Início</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtinicio) }} - {{ Funcoes.formatTimeFromJson(objView.hrinicio) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Data/Hora Fim</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtfim) }} - {{ Funcoes.formatTimeFromJson(objView.hrfim) }}</div>
            </div>
        </div>
    </div>


    <div v-if="lsDados.length>0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Data</th>
                    <th>Hora</th>
                    <th>Descrição</th>
                    <th>Operador</th>
                    <th>Horas/Km</th>
                    <th>Entregas</th>
                    <th>Coordenadas</th>
                    <th>Imagens</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(obj, index) in lsDados" :key="obj.id">
                    <tr :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" @click="toggleDetalhes(obj.id)">
                        <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtevento) }}</td>
                        <td class="col-width-date center">{{ Funcoes.formatTimeFromJson(obj.hrevento) }}</td>
                        <td>{{ obj.xtpevento }}</td>
                        <td class="col-width-char40">{{ obj.nmoperador }}</td>
                        <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.horaskm) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDecimal(obj.ttentregas, 1) }}</td>
                        <td class="col-width-char20 center label-link" @click.stop="abrirMapa(obj)">{{ obj.latitude }} x {{ obj.longitude }}</td>
                        <td class="col-width-char10 center label-link" @click.stop="abrirFotos(obj)">{{ (obj.idanexo) || (obj.idanexo2) ? 'SIM' : 'NÃO' }}</td>
                    </tr>
                    <tr v-if="detalhesAbertos.includes(obj.id)" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td colspan="8">
                            <strong>{{ obj.xmanual }}</strong> - {{ obj.nmusuario }}
                        </td>
                    </tr>
                    <tr v-if="detalhesAbertos.includes(obj.id) && obj.obs" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td colspan="9" class="col-width-char30">
                            <strong>Observações:</strong>{{ obj.obs }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>



    <div v-if="fotosEvento.length" class="evento-fotos-box">
        <div class="evento-fotos-grid">
            <div
                v-for="foto in fotosEvento"
                :key="foto.id"
                class="foto-card"
            >
                <div class="foto-preview" @click="visualizarFoto(foto.url)">
                    <img :src="foto.url" :alt="foto.titulo" />
                </div>

                <div class="foto-actions">
                    <span class="foto-titulo">{{ foto.titulo }}</span>
                    <button class="btn-foto" @click="abrirFotoNovaAba(foto.url)">
                        Abrir em nova aba
                    </button>
                </div>
            </div>
        </div>
    </div>


    <div v-if="showFotoModal" class="foto-modal-overlay" @click="showFotoModal = false">
        <div class="foto-modal-content" @click.stop>
            <button class="foto-modal-close" @click="showFotoModal = false">×</button>

            <img :src="fotoModalUrl" alt="Foto ampliada" class="foto-modal-img" />

            <div class="foto-modal-actions">
                <button class="btn-foto" @click="abrirFotoNovaAba(fotoModalUrl)">
                    Abrir em nova aba
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';

const emit=defineEmits(['close']);
const props=defineProps({idView: {type: Number, default: 0}});

const errorMessage = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const detalhesAbertos = ref([]);
const objView = ref({});

const fotosEvento = ref([]);
const showFotoModal = ref(false);
const fotoModalUrl = ref('');


const abrirFotos = async(obj) =>{
    fotosEvento.value = [];
    errorMessage.value = null;

    if ((!obj.idanexo) && (!obj.idanexo2)){
        errorMessage.value = 'Evento não possui fotos anexadas';
        return;
    }
    
    try {
        errorMessage.value = null;
        if (obj.idanexo){
            const r = await Api.genericPost('/main/solicitar/download', {id: obj.idanexo});
            if (r.bolok === 1 && r.download_url){
                fotosEvento.value.push({
                    id: obj.idanexo,
                    url: r.download_url,
                    titulo: 'Foto 1'
                });
            }
        }

        if (obj.idanexo2){
            const r = await Api.genericPost('/main/solicitar/download', {id: obj.idanexo2});
            if (r.bolok === 1 && r.download_url) {
                fotosEvento.value.push({
                    id: obj.idanexo2,
                    url: r.download_url,
                    titulo: 'Foto 2'
                });
            }
        }

        if (fotosEvento.value.length === 0) {
            errorMessage.value = 'Não foi possível carregar as fotos do evento';
        }
    } catch (error) {
        errorMessage.value = `Erro ao carregar fotos: ${error.message}`;
    }
}


const abrirFotoNovaAba = (url) => {
    window.open(url, '_blank');
}


const abrirMapa = async(obj) =>{
    if ((!obj.latitude) || (!obj.longitude)){
        errorMessage.value = 'Evento não possui coordenadas';
    }else{
        errorMessage.value = null;
        const zoom = 15;
        const url = `https://www.google.com/maps?q=${obj.latitude},${obj.longitude}&t=k&z=${zoom}`;
        window.open(url, '_blank');
    }
}

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        errorMessage.value = null;
        isLoading.value    = true;
        const req = await Api.genericPost('/os/vwos', {idmunicipio: globalStore.idmunicipio, idos: props.idView});
        Object.assign(objView.value, req[0]);

        const h = await Api.genericGet('/os/historico', {id: props.idView});
        lsDados.value = h;
    }catch (error){errorMessage.value = error;
    }finally{isLoading.value = false;}
}


function toggleDetalhes(id) {
    if (detalhesAbertos.value.includes(id)) {
        detalhesAbertos.value = detalhesAbertos.value.filter(x => x !== id)
    } else {
        detalhesAbertos.value.push(id)
    }
}


const visualizarFoto = (url) => {
    fotoModalUrl.value = url;
    showFotoModal.value = true;
}


onMounted(lerDados)
</script>


<style scoped>
.evento-fotos-box {
    margin-top: 16px;
    padding: 8px;
}

.evento-fotos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
    gap: 16px;
}

.foto-card {
    border-radius: 10px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 3px 8px rgba(0,0,0,0.08);
    transition: transform 0.15s ease;
}

.foto-card:hover {
    transform: translateY(-2px);
}

.foto-preview {
    width: 100%;
    height: clamp(260px, 30vw, 420px);
    background: #eef4f8;
    cursor: pointer;
    overflow: hidden;
}

.foto-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.35s ease;
}

.foto-preview:hover img {
    transform: scale(1.08);
}

.foto-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
}

.foto-titulo {
    font-size: 0.85rem;
    color: #6b7280;
    font-weight: 500;
}

.btn-foto {
    border: none;
    background: transparent;
    color: #3b82f6;
    font-size: 0.8rem;
    cursor: pointer;
    padding: 4px;
}

.btn-foto:hover {
    text-decoration: underline;
}

.foto-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.78);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
}

.foto-modal-content {
    position: relative;
    max-width: 96vw;
    max-height: 96vh;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.22);
}

.foto-modal-img {
    max-width: 92vw;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 8px;
    background: #f8fafc;
}

.foto-modal-close {
    position: absolute;
    top: 8px;
    right: 8px;
    border: none;
    background: rgba(0,0,0,0.65);
    color: #fff;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}

.foto-modal-actions {
    display: flex;
    justify-content: flex-end;
}

.btn-foto-modal {
    font-size: 0.9rem;
}
</style>